import React, { useState, useEffect } from "react";
import moment from "moment";
//outsource
import { Row, Col, Layout, Space, Spin } from "antd";
import { URL } from "../00_Nav/url";

//components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import CashupReportTopbar from "./component/cashup_report_topbar";
import CashupReportTable from "./component/cashup_report_table";

//redux
import { useDispatch, useSelector } from "react-redux";
import { incomeSelector } from "../../store/cashup/cashup.selector";

import { branchesOwnerSelector } from "../../store/branch/branch.selector";
import {
  snapAllIncomeByDate,
  unSnapIncome,
} from "../../store/cashup/cashup.action";
import {
  snapBranchesByOwnerId,
  unSnapBranchesByOwner,
} from "../../store/branch/branch.action";

//style
import "./style.css";

import { getData } from "./function/get_data";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import { UnSnapAllStaff, snapAllStaffs } from "../../store/staff/staff.action";

const { Content } = Layout;

const CashupReportList = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Report", url: URL.report },
    { title: "Cashup Report", url: URL.cashupReportList },
  ];

  // -------------------------- STATE --------------------------
  const [branch, setBranch] = useState("");
  const [from, setFrom] = useState(moment().startOf("week"));
  const [to, setTo] = useState(moment().endOf("week"));
  const [status, setStatus] = useState("All");
  const [loadingData, setLoadingData] = useState(true);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchesOwnerSelector);
  const cashUp = useSelector(incomeSelector);

  // let dateList = getDateArray(from, to);

  // -------------------------- FUNCTION --------------------------

  // const getDateArray = (from, to) => {
  //   let dateArray = [];
  //   const fromDate = from.toDate();
  //   const toDate = to.toDate();
  //   for (let i = fromDate; i <= toDate; i = moment(i).add(1, "day")) {
  //     dateArray.push(moment(i).format("DD/MM/YYYY"))
  //   }
  //   return dateArray
  // };

  // -------------------------- EFFECT --------------------------

  useEffect(() => {
    dispatch(snapBranchesByOwnerId());
    dispatch(snapAllStaffs());

    return () => {
      dispatch(unSnapBranchesByOwner());
      dispatch(UnSnapAllStaff());
    };
  }, [dispatch]);

  useEffect(() => {
    console.log(from, to);
    if (from && to) {
      dispatch(snapAllIncomeByDate({ from, to }, () => setLoadingData(false)));
    }
    return () => dispatch(unSnapIncome());
  }, [dispatch, from, to]);

  // -------------------------- RENDER --------------------------
  const data = cashUp?.length > 0 ? getData(cashUp, branchs) : [];
  let reportData = data;

  if (status !== "All") {
    reportData = reportData?.filter((item) => item.status === status);
  }
  if (branch !== "") {
    reportData = reportData?.filter((item) => item.branch === branch);
  }

  const renderBody = () => {
    if (!loadingData) {
      return (
        <Row style={{ margin: "20px 0px" }}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <CashupReportTopbar
              branch={branch}
              setBranch={setBranch}
              from={from}
              setFrom={setFrom}
              to={to}
              setTo={setTo}
              status={status}
              setStatus={setStatus}
              reportData={reportData}
              cashUpList={cashUp}
              branchs = {branchs}
            />
          </Col>
          <Col style={{ marginTop: 10 }} xl={24} lg={24} md={24} xs={24}>
            <CashupReportTable data={reportData} />
          </Col>
        </Row>
      );
    }
    return (
      <Space
        direction="vertical"
        style={{
          marginTop: 200,
          width: "100%",
        }}
      >
        <Spin tip="Loading table data..." size="small">
          <div className="content" />
        </Spin>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default CashupReportList;
